import React, {Component} from "react";
import {ReactSVG} from "react-svg";

import * as formulaInfoData from "../../../../../constants/formulaInfoData";
import * as tooltipHelper from "../../../../../helpers/tooltipHelper";
import * as translationHelper from "../../../../../helpers/translationHelper";

import imgExterior from "../../../../../resources/img/svgicons/exterior.svg";
import imgInterior from "../../../../../resources/img/svgicons/interior.svg";
import imgInvalid from "../../../../../resources/img/svgicons/invalid.svg";
import imgSolvent from "../../../../../resources/img/svgicons/solvent.svg";
import imgUniversal from "../../../../../resources/img/svgicons/universal.svg";
import imgWater from "../../../../../resources/img/svgicons/water.svg";

export default class FormulaProperties extends Component {
    getFormulaProperties = () => {
        const properties = this.getFormulaDestinationIcon();

        let img1, img2;
        switch (this.props.colorantsGroupId) {
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_SOLVENT_BASED:
                img1 = imgSolvent;
                break;
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_UNIVERSAL:
                img1 = imgUniversal;
                break;
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_UNIVERSAL_SOLVENT_BASED:
                img1 = imgUniversal;
                img2 = imgSolvent;
                break;
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_UNIVERSAL_WATER_BASED:
                img1 = imgUniversal;
                img2 = imgWater;
                break;
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_WATER_BASED:
                img1 = imgWater;
                break;
            case formulaInfoData.FORMULA_COLORANT_GROUP_ID_WATER_BASED_SOLVENT_BASED:
                img1 = imgInvalid;
                break;
            default:
                return "";
        }

        properties.push(
            <ReactSVG
                key={2}
                src={img1}
                alt={"colorants group icon"}
                className={"svg react-svg-icon " + (this.props.iconClassName ?? "")}
                data-text={translationHelper.getFormulaColorantPropertiesTranslations(
                    this.props.colorantsGroupId,
                    true
                )}
                onMouseEnter={tooltipHelper.createTooltip}
                wrapper="span"
            />
        );

        if (img2) {
            properties.push(
                <ReactSVG
                    key={3}
                    src={img2}
                    alt={"colorants group icon 2"}
                    className={"svg react-svg-icon " + (this.props.iconClassName ?? "")}
                    data-text={translationHelper.getFormulaColorantPropertiesTranslations(this.props.colorantsGroupId)}
                    onMouseEnter={tooltipHelper.createTooltip}
                    wrapper="span"
                />
            );
        }

        return properties;
    };

    getFormulaDestinationIcon = () => {
        let img;
        switch (this.props.destinationId) {
            case formulaInfoData.FORMULA_DESTINATION_ID_EXTERIOR:
                img = imgExterior;
                break;
            case formulaInfoData.FORMULA_DESTINATION_ID_INTERIOR:
                img = imgInterior;
                break;
            default:
                return [];
        }

        return [
            <ReactSVG
                key={1}
                src={img}
                alt={"destination icon"}
                className={"svg react-svg-icon " + (this.props.iconClassName ?? "")}
                data-text={translationHelper.getFormulaDestinationPropertiesTranslations(this.props.destinationId)}
                onMouseEnter={tooltipHelper.createTooltip}
                wrapper="span"
            />
        ];
    };

    render() {
        const properties = this.getFormulaProperties();

        if (properties.length === 0) {
            return null;
        }

        return (
            <div
                className={"flex height-100per " + (this.props.className ?? "")}
                style={{minWidth: properties.length * 35 + "px"}}
            >
                {properties}
            </div>
        );
    }
}
